import { observer } from 'mobx-react-lite'
import { useEffect } from 'react'
import './index.css'
import {
  Button,
  Col,
  ConfigProvider,
  Form,
  Input,
  Row,
  Select,
  Space,
  Table,
  Tooltip,
} from 'antd'
import { CommonStore, TaskManageStore } from '../../../store'
function CallManage() {
  const [form] = Form.useForm()
  const { Column } = Table
  const { Option } = Select

  useEffect(() => {
    form.setFieldsValue({
      botStatus: null,
      botName: null,
    })
    resetSearchBth();
  }, [])
  // 搜索
  const searchBtn = () => {
    TaskManageStore.resetPage();
    TaskManageStore.getTaskPage();
  }
  //重置
  const resetSearchBth = () => {
    TaskManageStore.setSearchForm({});
    searchBtn();
  };
  const getFormData = (changeValue: any, allValues: any) => {
    TaskManageStore.setSearchForm({ ...allValues })
  }
  return (
    <div className="allContent">
      <div className="formContent">
      <Form
        form={form}
        initialValues={TaskManageStore.searchForm}
        autoComplete="off"
        labelCol={{ span: 6 }}
        onValuesChange={getFormData}
        onKeyDown={(e) => {
          if (e.key.toLowerCase() === 'enter') {
            searchBtn()
          }
        }}
      >
        <Row justify="start">
        <Col span={8}>
            <Form.Item label="状态" name="botStatus">
              <Select style={{ width: '98%' }}>
                {/*<Option value={true}>启用</Option>*/}
                {/*<Option value={false}>禁用</Option>*/}
                <Option value={''}>全部</Option>
              </Select>
            </Form.Item>
          </Col>
          <Col span={8}>
            <Form.Item label="机器人名称" name="botName">
              <Input placeholder="请输入机器人名称" />
            </Form.Item>
          </Col>
          <Col offset={2}>
            <Form.Item>
              <Space>
                <Button type="primary" onClick={searchBtn}>
                  搜索
                </Button>
                <Button htmlType="reset" onClick={resetSearchBth}>
                  重置
                </Button>
              </Space>
            </Form.Item>
          </Col>
        </Row>
      </Form>
      <ConfigProvider renderEmpty={CommonStore.tableEmptyRender}>
            <Table
              dataSource={TaskManageStore.tableData.records}
              rowKey={(record) => record.no}
              loading={TaskManageStore.tableLoad}
              scroll={{ x: 1300 }}
              pagination={{
                current: TaskManageStore.pageData.page,
                pageSize: TaskManageStore.pageData.size,
                onChange: TaskManageStore.pageData.changePage,
                pageSizeOptions: [10, 20, 50, 100],
                showSizeChanger: true,
                total: TaskManageStore.tableData.total,
                showTotal: () =>
                  `共计${TaskManageStore.tableData.total}条`,
                position: ["bottomLeft"],
              }}
            >
              <Column
                fixed="left"
                ellipsis={true}
                width={150}
                title="机器人ID"
                dataIndex="botId"
                render={(no) => (
                  <Tooltip placement="topLeft" title={no}>{no}</Tooltip>
                )}
              />
              <Column
                ellipsis={true}
                width={150}
                title="机器人名称"
                dataIndex="botName"
                render={(no) => (
                  <Tooltip placement="topLeft" title={no}>{no}</Tooltip>
                )}
              />
              <Column
                ellipsis={true}
                width={150}
                title="机器人英文名称"
                dataIndex="botNameEn"
                render={(no) => (
                  <Tooltip placement="topLeft" title={no}>{no}</Tooltip>
                )}
              />
              <Column
                title="备注"
                width={150}
                dataIndex="remark"
                ellipsis={true}
              />
              <Column
                ellipsis={true}
                width={150}
                title="更新时间"
                dataIndex=""
              />
              <Column
                ellipsis={true}
                width={100}
                title="状态"
                dataIndex="botStatus"
              />
               <Column
                ellipsis={true}
                width={100}
                title="机器人并发"
                dataIndex="concurrency"
              />
              <Column
            title="所属平台"
            width={120}
            dataIndex="platform"
            render={(platform) => (platform ==1?'火山':platform ==2?'前景':'科大')}
            ellipsis={true}
          />
            </Table>
          </ConfigProvider>
    </div>
    </div> 
  )
}
export default observer(CallManage)
